var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"path-pair",on:{"click":function($event){return _vm.gotoPath()}}},[_c('span',[_vm._t("default")],2),_c('i',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.separatorIcon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }